import { EasyRideWidget } from "./EasyRideWidget.js";
import { BoxWidget } from "./BoxWidget.js";
import { TextWidget } from "./TextWidget.js";
import { CTAButton } from "../front/widgets/CTAButton.js";
import { TabsWidget } from "../front/TabsWidget.js";
import { GridWidget } from "../front/widgets/GridWidget.js";

export class VehiclesListApp {
    constructor(pmdrs, config) {
        let app = this;
        app.pmdrs = pmdrs;
        //CONFIG
        this.config = this.defaultConfig();
        Object.assign(this.config, config);

        // Get the current URL query string
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        // override tabs widget setting        
        if (urlParams.get('useTabsWidget') === 'true') {
            this.config.useTabsWidget = true;
        }
        
        this.forceGridWidget = urlParams.get('useGridWidget') === 'true';
        this.forceTextWidget = urlParams.get('useTextWidget') === 'true';

        //ATTS
        this.gettingPmSiteSettings = true;//will be used on functions endpoint to wait
        this.enabled = false;//true after checking site settings
        this.widgetsByVin = {}; //to not reinitialize
        this.lastFrontApp = null;

        //GET PM SITE SETTINGS <-- THIS SHOULD BE THE ONLY ONE API CALL FOR PM SETTINGS
        app.pmdrs.pmApi.pmSiteSettings.getPmSettings(
            app.pmdrs.config.accountId,
            {},
            // SUCCESS
            (response) => {
                var settings = JSON.parse(response);
                app.siteSettings = settings;
                app.gettingPmSiteSettings = false;
                if (
                    settings.enable &&
                    app.onlyAdminsCheck()
                ) {
                    app.init();
                } else {
                    console.info("PMDRS Vehicles List App not enabled");
                }
            },
            // ERROR
            (response) => {
                console.error("Error getting PM Site Settings");
                app.gettingPmSiteSettings = false;
            }
        );        
    }

    onlyAdminsCheck() {
        return !this.siteSettings.onlyAdmins || (this.siteSettings.onlyAdmins && this.pmdrs.config.adminLoggedIn);
    }    

    init() {
        let app = this;

        app.enabled = true;//It's false while not init
    }

    defaultConfig() {
        return {            
            recaptchaSiteKey: "your_site_key",
            easyRideClass: 'pmdrs-easy-ride',
            boxWidgetClass: 'pmdrs-easy-ride',//default easy ride to have it working like it is
            ctaButtonClass: 'pmdrs-vlp-button',
            tabsWidgetClass: 'pmdrs-easy-ride',//to use the same spot as boxWidget, not at the same time btm
            gridWidgetClass: 'pmdrs-easy-ride',//to use the same spot as boxWidget, not at the same time btm
            textWidgetClass: 'pmdrs-easy-ride',//to use the same spot as boxWidget, not at the same time
            useTabsWidget: false,
        };
    }

    /**
     * 
     * @param Array of vehicles, vehicle item example (the same as FrontApp)
     * [ {
                finalPrice: "35525", //listedPrice
                retailPrice: "42525", //MSRP
                dealerDiscounts: 0,
                dealerMarkups: 0,
                condition: "new", //new, used
                vin: "1C4HJXDGXMW840919", //,'2C3CCARG3MH649453',//'3N1CN8BV8LL870448',
                stockNumber: "345687",
                mileage: "1",
                year: "2021",
                make: "JEEP",
                model: "Wrangler",
                trim: "123456",
                vehicleKey: "",//example 2021jeepwrangler123456
                label: "2021 Jeep Wrangler 123456",
                vdpUrl: "#vdpUrl",
                imgUrl: "https://es.ramtrucks.com/content/dam/fca-brands/na/ramtrucks/en_us/bhp/lineup/RAM-BHP-LINEUP-TRX-Two-Tone.jpg.image.500.jpg",
                pricing: {}, //PM structure attribute, use with carefull because DRS is not in controll of that structure
                accessories: [], //PM structure attribute, use with carefull because DRS is not in controll of that structure
            }
        ]
     */
    renderVehiclesList(vehicles){
        console.log('Render Vehicles List');        
        var app = this;

        if(this.gettingPmSiteSettings){
            setTimeout(() => {
                app.renderVehiclesList(vehicles)
            }, 200);
        }else{
            if(!app.enabled) return;//skip
            
            // re-use initialized vehicles
            var missingVehicles = [];
            vehicles.forEach(vehicle => {
                let existingWidgets = app.widgetsByVin[vehicle.vin];
                if(existingWidgets){
                    // A caller that tracks a real DOM element per vehicle (e.g. pmdra-embed.js,
                    // re-rendering after the host page rebuilt its own DOM) passes a fresh
                    // vehicle.containerElement here — update the cached widgets' target before
                    // re-init'ing them, or they'd silently write into a now-detached node.
                    // No-op for every other caller (vehicle.containerElement is never set).
                    if (vehicle.containerElement) {
                        if (existingWidgets.boxWidget) existingWidgets.boxWidget.setContainerElement(vehicle.containerElement);
                        if (existingWidgets.ctaBtn) existingWidgets.ctaBtn.setContainerElement(vehicle.containerElement);
                        if (existingWidgets.textWidget) existingWidgets.textWidget.setContainerElement(vehicle.containerElement);
                        if (existingWidgets.gridWidget) existingWidgets.gridWidget.setParentContainerElement(vehicle.containerElement);
                    }
                    // Same relative order as the fresh-vehicle creation branches below
                    // (box/grid/text/tabs widget first, ctaBtn last) — both widgets
                    // append into the same container element, so a mismatched order here
                    // flips their visual stacking depending on whether a vehicle was
                    // previously rendered (cache hit) or not (cache miss).
                    if(existingWidgets.easyRideWidget){
                        existingWidgets.easyRideWidget.init();
                    }
                    if(existingWidgets.boxWidget){
                        existingWidgets.boxWidget.init();
                    }
                    if(existingWidgets.gridWidget){
                        existingWidgets.gridWidget.init();
                    }
                    if(existingWidgets.textWidget){
                        existingWidgets.textWidget.init();
                    }
                    if(existingWidgets.tabsWidget){
                        existingWidgets.tabsWidget.init();
                    }
                    if(existingWidgets.ctaBtn){
                        existingWidgets.ctaBtn.init();
                    }
                }else{                    
                    missingVehicles.push(vehicle);
                }
            });

            //call implementations for missing vehicles only
            if(missingVehicles.length != 0){
                if(this.pmdrs.dataDriver.isLenderDesk()){
                    app.lenderDeskImplementation(missingVehicles);
                }else{
                    app.pmPaymentsImplementation(missingVehicles);
                }        
            }else{
                //fire event to notify that DRS VLPs are updated so the host site can adjust layout if needed
                //this event fires also inside implementations after async calls
                app.fireDrsVlpUpdatedEvent();                  
            }
        }
    }

    fireDrsVlpUpdatedEvent(){
        document.body.dispatchEvent(new Event('drsvlp:updated'));
    }

    createTabsWidget(vehicle, apiPayments, ctaBtnWidget){
        var app = this;
        var tabsWidget = new TabsWidget(app, vehicle);
        let pDataByDeal = {};
        app.pmdrs.allDealTypes.forEach(function(dealType){
            let pData = apiPayments[dealType];
            if(pData){
                pDataByDeal[dealType] = app.pmdrs.dataDriver.formatApiPayment(pData);
            }
        });
        tabsWidget.init(pDataByDeal);
        tabsWidget.setBtnClickCallback((dealType)=> {
            ctaBtnWidget.click(dealType);
        });
        return tabsWidget;
    }

    // Payment-disclosure compliance: VLP price previews (box/grid/text/tabs widget) show
    // payments without the disclosures the VDP tabs widget now carries, so the listing
    // renders only the CTA button regardless of the onlyButtonOnVLP/vlpWidgetType settings.
    isOnlyButtonOnVLP() {
        return true;
    }

    getVlpWidgetType() {
        if (this.forceTextWidget) return 'text';
        if (this.forceGridWidget) return 'grid';
        // new setting, falls back to old useGridWidget boolean for existing configs
        return this.siteSettings.vlpWidgetType || (this.siteSettings.useGridWidget ? 'grid' : 'box');
    }

    /**
     * used by box widget and text widget (single-payment widgets), grid widget shows all deal types so it's not affected
     * admin setting "Vehicle Listing App Default Payment" (vlpDefaultPayment), defaults to 'lease' to keep existing behavior
     */
    getVlpPaymentPriority() {
        switch (this.siteSettings.vlpDefaultPayment) {
            case 'finance':
                return ['finance', 'lease', 'balloon', 'cash'];
            case 'balloon':
                return ['balloon', 'lease', 'finance', 'cash'];
            case 'cash':
                return ['cash', 'lease', 'balloon', 'finance'];
            default:
                return ['lease', 'balloon', 'finance', 'cash'];
        }
    }

    pickVlpPayment(payments) {
        let priority = this.getVlpPaymentPriority();
        for (const dealType of priority) {
            if (payments[dealType]) return payments[dealType];
        }
        return null;
    }

    /**
     * text/box widgets show a single payment and read poorly as a bare price with no financing info,
     * so skip them entirely when cash is the only deal type available for the vehicle —
     * unless the dealer set cash as the VLP default payment, then a bare cash price is what they asked for
     */
    isOnlyCashAvailable(payments) {
        if (this.siteSettings.vlpDefaultPayment === 'cash') return false;
        return !this.pmdrs.allDealTypes.some(dealType => dealType !== 'cash' && payments[dealType]);
    }

    createGridWidget(vehicle, apiPayments){
        var app = this;
        var gridWidget = new GridWidget(app, vehicle);
        let pDataByDeal = {};
        let paymentsToShow = [...app.pmdrs.allDealTypes];
        paymentsToShow.push('finance_lower_rate'); // workaround type only for grid widget for delamo
        paymentsToShow.forEach(function(dealType){
            let pData = apiPayments[dealType];
            if(pData){
                pDataByDeal[dealType] = app.pmdrs.dataDriver.formatApiPayment(pData);
            }
        });
        if (vehicle.containerElement) {
            gridWidget.setParentContainerElement(vehicle.containerElement);
        } else {
            gridWidget.setParentContainerSelector(`.${this.config.gridWidgetClass}[data-vin="${vehicle.vin}"]`);
        }
        gridWidget.init(pDataByDeal);
        return gridWidget;
    }

    /**
    * @param vehicles same as renderVehiclesList
    * do not request pm?cache endpoint, no ratesheets, just init
    */ 
    lenderDeskImplementation(vehicles){
        var app = this;
        var vins =  Object.values(vehicles).map(vehicle => vehicle.vin);

        app.pmdrs.pmApi.getLenderDeskVinListPayments(app.pmdrs.config.accountId, 
            { vins: vins }, response => {
            var vinList = JSON.parse(response);
            console.log(vinList);      
            vehicles.forEach(vehicle => {
                let payments = vinList[vehicle.vin];                    
                if(!payments) return;//skip if not in response
                                   
                var tabsWidget = null;
                var boxWidget = null;
                var gridWidget = null;
                var textWidget = null;

                if(app.config.useTabsWidget && !app.isOnlyButtonOnVLP()){//TABS WIDGET
                    //CTA Button widget
                    var ctaBtn = new CTAButton(app, vehicle, {hide:true}, vehicle.containerElement);
                    ctaBtn.init({}, true);//force it, because not allowe or expired in v2
                    tabsWidget = app.createTabsWidget(vehicle, payments, ctaBtn);
                }else{
                    var payment = app.pickVlpPayment(payments);
                    if(!payment) return;
                    let pData = app.pmdrs.dataDriver.formatApiPayment(payment);

                    // onlyButtonOnVLP: VLP counterpart to the existing onlyButtonOnVDP —
                    // skip the price-preview widget entirely, render only the CTA
                    // button below (which still needs pData, so this only gates
                    // widget creation, not the payment lookup above it).
                    const onlyButtonOnVLP = app.isOnlyButtonOnVLP();
                    const widgetType = app.getVlpWidgetType();
                    const onlyCash = app.isOnlyCashAvailable(payments);
                    if (onlyButtonOnVLP) {
                        // no box/grid/text widget
                    } else if (widgetType === 'grid') {
                        gridWidget = app.createGridWidget(vehicle, payments);
                    } else if (widgetType === 'text') {
                        if (!onlyCash) {
                            textWidget = new TextWidget(app, vehicle, vehicle.containerElement);
                            textWidget.init(pData);
                        }
                    } else if (!onlyCash) {
                        boxWidget = new BoxWidget(app, vehicle, vehicle.containerElement);
                        boxWidget.init(pData);
                    }

                    var ctaBtn = new CTAButton(app, vehicle, undefined, vehicle.containerElement);
                    ctaBtn.init(pData, true);//force it
                }


                app.widgetsByVin[vehicle.vin] = {
                    gridWidget: gridWidget,
                    tabsWidget: tabsWidget,
                    boxWidget: boxWidget,
                    textWidget: textWidget,
                    ctaBtn: ctaBtn
                }
            });
            //fire event to notify that DRS VLPs are updated so the host site can adjust layout if needed
            app.fireDrsVlpUpdatedEvent();
        },
        errorResponse => {
            console.error("Error getting lenderDeskVinList");
        });
    }

    /**
    * @param vehicles same as renderVehiclesList
    * do not request pm?cache endpoint, no ratesheets, just init
    */ 
    pmPaymentsImplementation(vehicles){
        var app = this;
        var vins =  Object.values(vehicles).map(vehicle => vehicle.vin);

        app.pmdrs.pmApi.getPmPaymentsBySite(app.pmdrs.config.accountId, 
            { vins: vins }, response => {
            var vinList = JSON.parse(response);
            console.log(vinList);      
            vehicles.forEach(vehicle => {
                let payments = vinList[vehicle.vin];                    
                if(!payments) return;//skip if not in response            
                
                var tabsWidget = null;
                var boxWidget = null;
                var gridWidget = null;
                var textWidget = null;

                if(app.config.useTabsWidget && !app.isOnlyButtonOnVLP()){//TABS WIDGET
                    //CTA Button widget
                    var ctaBtn = new CTAButton(app, vehicle, {hide:true}, vehicle.containerElement);
                    ctaBtn.init({}, true);//force it, because not allowe or expired in v2
                    tabsWidget = app.createTabsWidget(vehicle, payments, ctaBtn);
                } else {
                    var boxPayment = app.pickVlpPayment(payments);
                    if (!boxPayment) return;
                    let pData = app.pmdrs.dataDriver.formatApiPayment(boxPayment);

                    // onlyButtonOnVLP: VLP counterpart to the existing onlyButtonOnVDP —
                    // skip the price-preview widget entirely, render only the CTA
                    // button below (which still needs pData, so this only gates
                    // widget creation, not the payment lookup above it).
                    const onlyButtonOnVLP = app.isOnlyButtonOnVLP();
                    const widgetType = app.getVlpWidgetType();
                    const onlyCash = app.isOnlyCashAvailable(payments);
                    if (onlyButtonOnVLP) {
                        // no box/grid/text widget
                    } else if (widgetType === 'grid') {
                        gridWidget = app.createGridWidget(vehicle, payments);
                    } else if (widgetType === 'text') {
                        if (!onlyCash) {
                            textWidget = new TextWidget(app, vehicle, vehicle.containerElement);
                            textWidget.init(pData);
                        }
                    } else if (!onlyCash) {
                        boxWidget = new BoxWidget(app, vehicle, vehicle.containerElement);
                        boxWidget.init(pData);
                    }

                    //CTA Button widget
                    var ctaBtn = new CTAButton(app, vehicle, undefined, vehicle.containerElement);
                    ctaBtn.init(boxPayment, true);//force it, because not allowe or expired in v2
                }

                app.widgetsByVin[vehicle.vin] = {
                    gridWidget: gridWidget,
                    boxWidget: boxWidget,
                    textWidget: textWidget,
                    tabsWidget: tabsWidget,
                    ctaBtn: ctaBtn
                }           
            });
            //fire event to notify that DRS VLPs are updated so the host site can adjust layout if needed
            app.fireDrsVlpUpdatedEvent();
        },
        errorResponse => {
            console.error("Error getting lenderDeskVinList");
        });
    }

    formatVehiclesForRequest(vehicles) {
        return Object.values(vehicles).map(vehicle => ({
            make: vehicle.make,
            model: vehicle.model,
            year: vehicle.year,
            trim: vehicle.trim,
            vdkey: vehicle.vehicleKey,
            vin: vehicle.vin,
            msrp: vehicle.retailPrice,
            final: vehicle.finalPrice || vehicle.retailPrice//use MSRP as final if final is 0
        }));
    }

}
